module.exports = __webpack_public_path__ + "img/rollcall_4.c6c760c9.png";